import { SelectableTablePossibleCellsType } from '../../components/SelectableTable/SelectableTable.types';
import { SourceSystemType } from '../../models/examSessionDto.types';
import { IPageInfo } from '../../models/page.types';

export interface ExamineeListTableItem {
  [key: string]: SelectableTablePossibleCellsType;
  id: string;
  examCommittee: JSX.Element;
  schoolCode: string;
  examineeCode: string;
  examineePesel: string;
  examName: string;
  sheetCode: string;
  room: string;
  importDate: JSX.Element;
  status: JSX.Element;
  actions: JSX.Element;
}

export type ExamineeListSortBy =
  | 'examCommittee'
  | 'schoolCode'
  | 'examineeCode'
  | 'examineePesel'
  | 'examName'
  | 'sheetCode'
  | 'room'
  | 'importDate'
  | 'status'
  | 'actions';

export interface Examinee {
  adjustments: string;
  examCommittee: string;
  schoolCode: string;
  examineeCode: string;
  examineePesel: string;
  examName: string;
  sheetCode: string;
  room: string;
  importDate: string;
  status: ExamineeStatus;
  examineeId: string;
  assessmentSessionsClosed: boolean;
  sourceSystemTypeId: SourceSystemType;
  examSheetId: string;
}

export enum ExamineeStatus {
  Completed,
  Incomplete,
  Empty,
}

export interface ExamineeResponse {
  examinees: Examinee[];
  filter: {
    [key: string]: string;
  };
  page: IPageInfo;
  adjustmentTypes: Adjustment[] | null;
  adjustmentPermissions: Adjustment[] | null;
}

export interface Adjustment {
  id: string;
  name: string;
}

export enum ExamineeStatusPl {
  Completed = 'Karta kompletna',
  Incomplete = 'Karta niekompletna',
  Empty = 'Brak karty zdającego',
}
